export const pageType = {
  home: "1",
  list: "2",
  details: "3",
};

export const DefaultPage = 1;

export const TablePageSize = 25;

export const DOMAIN_CLINKS = process.env.REACT_APP_DOMAIN_CLINKS;
export const DOMAIN_MTC = process.env.REACT_APP_DOMAIN_MTC;

export const CLINKS_CLAIM_STATUS = {
  match: "1",
  is_admin: "2",
  no_match: "3",
};
